import {
  serialIdField,
  vehicleKeyField,
  statusField,
  certificateField,
  huManufacturedField,
  vehicleManufacturedField,
  purchasedField,
  vehicleGroupsField,
  vehicleFeaturesField,
  vehicleSubscriptionsField,
  lastSeenField,
} from "./SearchField";
import { CLIENT } from "../../../services/Constants";

const basicSearchFields = [
  serialIdField,
  vehicleKeyField,
  statusField,
  certificateField,
  vehicleManufacturedField,
  purchasedField,
  lastSeenField,
];

const clientSearchFields = {
  [CLIENT.HD]: [
    huManufacturedField,
    vehicleGroupsField,
    vehicleFeaturesField,
    vehicleSubscriptionsField,
  ],
  [CLIENT.MSIL]: [],
  [CLIENT.SKODA]: [vehicleFeaturesField, vehicleSubscriptionsField],
};

export const getSearchFields = (client) => {
  switch (client) {
    case CLIENT.MSIL:
      return [...basicSearchFields, ...clientSearchFields[CLIENT.MSIL]];
    case CLIENT.SKODA:
      return [...basicSearchFields, ...clientSearchFields[CLIENT.SKODA]];
    case CLIENT.HD:
      return [...basicSearchFields, ...clientSearchFields[CLIENT.HD]];
    default:
      return Array.from(
        new Set([
          ...basicSearchFields,
          ...Object.values(clientSearchFields).flat(),
        ])
      );
  }
};
